module.exports = __webpack_public_path__ + "media/styles/images/svg/annotation-gray-dark-bcb7b1a3e2aa3ee46abc628513a044fc.svg";